import axiosInstance from './axiosInstance';

const getKriptoStoreById = (id) =>
  axiosInstance.get(`/internal/admin/kriptostores/${id}`);

export default getKriptoStoreById;
